const defaultParticipants = [];

export default defaultParticipants;
